/**
 * "Skip to the items ↓" (proposal 9): the first Tab stop on Triage, Cases
 * and Done. A keyboard-only tester counted about 20 Tabs from the top of the
 * page to the first item. Hidden until focused, then shown in the page flow
 * right above the list; pressing it puts focus on the first item.
 *
 * tabIndex 1 is deliberate: the portal navbar comes first in the document,
 * and this link has to be reached with ONE Tab from the top of the page.
 * Only one door page renders at a time, so there is never a second one.
 */
import { trackEvent } from '../../services/portalTracking';
import { doorItems } from './doorFocus';
import styles from './SkipToItems.module.css';

export function SkipToItems({ list }: { list: 'triage' | 'cases' | 'done' }) {
  return (
    <a
      href="#door-items"
      className={styles.skip}
      tabIndex={1}
      data-testid="skip-to-items"
      onClick={(e) => {
        e.preventDefault();
        const first = doorItems()[0] ?? null;
        trackEvent('action', 'skip_to_items', {
          list,
          item: first?.dataset.doorItem ?? null,
          outcome: first ? 'focus_item' : 'no_items',
        });
        first?.focus();
        first?.scrollIntoView?.({ block: 'nearest' });
      }}
    >
      Skip to the items ↓
    </a>
  );
}
